import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'cupcake',
  size: 24,
  node: [
    ['path', { d: 'M12 22v-9', key: 'x3hkom' }],
    ['path', { d: 'M14 4h1a3 3 0 013 3l-.004.125A4 4 0 0121 11v2', key: '1uimk1' }],
    ['path', { d: 'm15.5 22 1.5-9', key: 'p3wz2u' }],
    [
      'path',
      {
        d: 'M21 13a1 1 0 01.919 1.394l-2.74 6.394A2 2 0 0117.34 22H6.659a2 2 0 01-1.838-1.212l-2.74-6.394A1 1 0 013 13z',
        key: 'dykv9l',
      },
    ],
    ['path', { d: 'M3 13v-2a4 4 0 013.003-3.875L6 7a3 3 0 013-3h1', key: '6kd3ki' }],
    ['path', { d: 'M8.5 22 7 13', key: '1l6g57' }],
    ['circle', { cx: '12', cy: '4', r: '2', key: 'muu5ef' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Cupcake
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjJ2LTkiIC8+CiAgPHBhdGggZD0iTTE0IDRoMWEzIDMgMCAwMTMgM2wtLjAwNC4xMjVBNCA0IDAgMDEyMSAxMXYyIiAvPgogIDxwYXRoIGQ9Im0xNS41IDIyIDEuNS05IiAvPgogIDxwYXRoIGQ9Ik0yMSAxM2ExIDEgMCAwMS45MTkgMS4zOTRsLTIuNzQgNi4zOTRBMiAyIDAgMDExNy4zNCAyMkg2LjY1OWEyIDIgMCAwMS0xLjgzOC0xLjIxMmwtMi43NC02LjM5NEExIDEgMCAwMTMgMTN6IiAvPgogIDxwYXRoIGQ9Ik0zIDEzdi0yYTQgNCAwIDAxMy4wMDMtMy44NzVMNiA3YTMgMyAwIDAxMy0zaDEiIC8+CiAgPHBhdGggZD0iTTguNSAyMiA3IDEzIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iNCIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cupcake
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cupcake = createLucideIcon(__iconData);

export default Cupcake;
